@if (state(); as s) {
  <div class="confirm-backdrop" (click)="onCancel()">
    <div
      class="confirm-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-message"
      (click)="$event.stopPropagation()"
    >
      <div class="confirm-dialog__icon" [class.confirm-dialog__icon--danger]="s.tone === 'danger'">
        <lucide-icon [img]="alertIcon" size="26"></lucide-icon>
      </div>

      <h2 id="confirm-title" class="confirm-dialog__title">{{ s.title }}</h2>
      <p id="confirm-message" class="confirm-dialog__message">{{ s.message }}</p>

      <div class="confirm-dialog__actions">
        <app-button variant="secondary" (buttonClick)="onCancel()">
          {{ s.cancelText }}
        </app-button>
        <app-button
          [variant]="s.tone === 'danger' ? 'danger' : 'primary'"
          (buttonClick)="onConfirm()"
        >
          {{ s.confirmText }}
        </app-button>
      </div>
    </div>
  </div>
}
